import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import _ from "lodash";
import $ from "jquery";
import { useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import EditMemberModal from "./EditMemberModal";
import Service from "../FacilityDashoardService";
import AuthService from "../../../Auth/AuthService";
import PermissionFeature from "../../../Permissions/PermissionFeature";
export default function HistoricMembersModel(props) {
  const { modal, InActiveMembers, toggle, reloadData } = props;
  const history = useHistory();
  const handleClose = () => {
    toggle();
  };
  const applyUniqueKey = (data) => {
    for (let i = 0; i < data.length; i++) {
      data[i].uniqueKey = i + 1;
    }
    return data;
  };

  const column = [
    {
      text: "Member Name (Reg/Facility)",
      dataField: "memberName",
      headerClasses: "text-nowrap bg-dark text-white px-sm-3 px-2 py-2",
      classes: "text-nowrap px-3 py-2 c-pointer",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <a
            alt="show Member profile"
            href={"/directory/userAction/" + row.memberID}
            onClick={(e) => {
              e.stopPropagation();

              e.nativeEvent.stopImmediatePropagation();
            }}
          >
            {row.memberName} ({row.region != null ? row.region : "--"}/
            {row.facility != null ? row.facility : "--"})
          </a>
        );
      },
    },
    {
      text: "Position",
      dataField: "positionName",

      headerClasses: "text-nowrap bg-dark text-white px-sm-3 px-2 py-2",
      classes: "text-nowrap px-3 py-2 c-pointer",
      sort: true,
    },
    {
      text: "Start Date",
      dataField: "startDate",

      headerClasses: "text-nowrap bg-dark text-white px-sm-3 px-2 py-2",
      classes: "text-nowrap px-3 py-2 c-pointer",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.startDate
              ? moment(row.startDate.split("T")[0]).format("MM/DD/YYYY")
              : "--"}
          </>
        );
      },
    },
    {
      text: "End Date",
      dataField: "endDate",

      sort: true,
      headerClasses: "text-nowrap bg-dark text-white px-3 py-2",
      classes: "px-3 py-2 c-pointer",
      formatter: (cellContent, row) => {
        return (
          <>
            {row.endDate
              ? moment(row.endDate.split("T")[0]).format("MM/DD/YYYY")
              : "--"}
          </>
        );
      },
    },
    {
      text: "Change Submitted By",
      dataField: "changeSubmitBy",

      sort: true,
      headerClasses: "text-nowrap bg-dark text-white px-3 py-2",
      classes: "px-3 py-2 c-pointer",
      formatter: (cellContent, row) => {
        return (
          <>
            {row.changeSubmitBy ? (
              <a
                alt="show Member profile"
                href={"/directory/userAction/" + row.changeSubmitById}
                onClick={(e) => {
                  e.stopPropagation();

                  e.nativeEvent.stopImmediatePropagation();
                }}
              >
                {row.changeSubmitBy}
              </a>
            ) : (
              "--"
            )}
          </>
        );
      },
    },
    {
      text: "Change Date",
      dataField: "changeDate",
      sort: true,
      headerClasses: "text-nowrap bg-dark text-white px-3 py-2",
      classes: "px-3 py-2 c-pointer",
      formatter: (cellContent, row) => {
        return (
          <div>
            {row.changeDate
              ? moment(row.changeDate.split("T")[0]).format("MM/DD/YYYY")
              : "--"}
          </div>
        );
      },
    },
    {
      text: "Action",
      hidden:
        !AuthService.canFacilityUpdate(
          PermissionFeature.FacilityRepresentatives
        ) &&
        !AuthService.canFacilityDelete(
          PermissionFeature.FacilityRepresentatives
        ),
      sort: false,
      headerClasses: "text-nowrap bg-dark text-white px-3 py-2",
      classes: "px-3 py-2 c-pointer",
      formatter: (cellContent, row) => {
        console.log(row);
        return (
          <div>
            {AuthService.canFacilityUpdate(
              PermissionFeature.FacilityRepresentatives
            ) && (
              <i
                className="fas fa-pencil-alt mr-2"
                onClick={() => {
                  setState({
                    ...state,
                    editPositionModalObj: row,
                    openEditPositionModal: true,
                  });
                }}
              ></i>
            )}
            {AuthService.canFacilityDelete(
              PermissionFeature.FacilityRepresentatives
            ) && (
              <i
                className="fas fa-trash text-danger mr-2"
                onClick={() => {
                  setState({
                    ...state,
                    delId: row.tpmid,
                    positionName: row.positionName,
                  });
                }}
                to="#"
                data-target=".delete-modal"
                data-toggle="modal"
                size="sm"
              ></i>
            )}
          </div>
        );
      },
    },
  ];
  const [state, setState] = useState({
    sizePerPage: 10,
    openEditPositionModal: false,
    editPositionModalObj: null,
    delId: -1,
  });
  const SizePerPageChange = (sizePerPage) => {
    setState({ ...state, sizePerPage: sizePerPage });
  };
  const closeEditPositionModal = () => {
    setState({ ...state, openEditPositionModal: false });
  };
  const RemotePagination = (data) => {
    let paginationOptions = {
      totalSize: !_.isEmpty(data) && data.length > 0 ? data.length : 0,
      showTotal: true,
      onSizePerPageChange: SizePerPageChange,
      sizePerPage: state.sizePerPage,

      //hidePageListOnlyOnePage: true
    };
    let defaultsort = [
      {
        dataField: "startDate",
        order: "desc",
      },
    ];
    return (
      <div>
        <BootstrapTable
          // remote
          keyField="uniqueKey"
          id="HistoricOfficer"
          data={data}
          defaultSortDirection="asc"
          defaultSorted={defaultsort}
          columns={column}
          className="table"
          pagination={
            (!_.isEmpty(data) && data.length > 0 ? data.length : 0) >
            state.sizePerPage
              ? paginationFactory({ ...paginationOptions })
              : false
          }
          // onTableChange={this.handleTableChange}
        />
      </div>
    );
  };
  const confirm = async () => {
    $(".loading").show();
    if (state.delId <= 0) {
      return false;
    }
    let data = await Service.DeleteHistoricalPosition(state.delId);
    if (data == true) {
      await setState({ delId: 0 });
      $(".delete-modal").trigger("click");
      reloadData();
      // here the $(".loading").hide() is not added as it will be hide in get representative method.
    } else {
      $(".loading").hide();
    }
  };

  return (
    <>
      <Modal
        centered={true}
        size="xl"
        autoFocus={true}
        isOpen={modal}
        toggle={toggle}
      >
        <ModalHeader>Representative History</ModalHeader>
        <ModalBody>
          <div className="row" id="tableRow">
            <div className="col-12" style={{ overflow: "scroll" }}>
              {!_.isEmpty(InActiveMembers) ? (
                RemotePagination(applyUniqueKey(InActiveMembers))
              ) : (
                <p className="mt-4 text-center">No Members Available!</p>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <ConfirmDeleteModal confirm={confirm} positionName={state.positionName} />
      <EditMemberModal
        openModal={state.openEditPositionModal}
        closeModal={closeEditPositionModal}
        setReloader={reloadData}
        position={state.editPositionModalObj}
      />
    </>
  );
}
